var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['wit-moduleHeader', _vm.$mq],style:({
    backgroundImage: ("url(" + _vm.publicPath + "images/bg_sections.svg)"),
  })},[_c('div',{staticClass:"container-xl"},[_c('div',{staticClass:"wit-moduleHeader__title col-md-12"},[_vm._v(" "+_vm._s(_vm.content)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }